module.exports = __webpack_public_path__ + "img/horizontal_4_5_0.f83a7e88.png";